/**
 * PeriodSwitcher — maand/kwartaal/jaar-schakelaar met periode-navigatie
 * voor de cijfers-pagina. Stil premium: rustige segmented control + pijlen.
 */

import { useCijfersStore, currentPeriod, formatPeriodLabel, shiftPeriod, type Grain } from '../../stores/cijfers-store';

const GRAIN_LABELS: Array<{ grain: Grain; label: string }> = [
  { grain: 'month', label: 'Maand' },
  { grain: 'quarter', label: 'Kwartaal' },
  { grain: 'year', label: 'Jaar' },
];

export function PeriodSwitcher() {
  const { grain, period, setGrain, setPeriod } = useCijfersStore();
  const isCurrent = period === currentPeriod(grain);

  return (
    <div className="flex items-center gap-4">
      <div className="flex rounded-lg border border-gray-200 bg-gray-50 p-0.5">
        {GRAIN_LABELS.map(({ grain: g, label }) => (
          <button
            key={g}
            onClick={() => setGrain(g)}
            className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
              grain === g
                ? 'bg-white text-main font-medium shadow-sm'
                : 'text-gray-500 hover:text-main'
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="flex items-center gap-1">
        <button
          onClick={() => setPeriod(shiftPeriod(period, grain, -1))}
          className="p-2 rounded-lg hover:bg-gray-100 text-gray-500 transition-colors"
          aria-label="Vorige periode"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <span className="text-sm font-medium text-main min-w-[130px] text-center">
          {formatPeriodLabel(period, grain)}
        </span>
        <button
          onClick={() => setPeriod(shiftPeriod(period, grain, 1))}
          disabled={isCurrent}
          className="p-2 rounded-lg hover:bg-gray-100 text-gray-500 transition-colors disabled:opacity-30 disabled:hover:bg-transparent"
          aria-label="Volgende periode"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
}
